import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Country extends Vue {
  get countries() {
    return [
      { text: this.$t('countries.de'), value: 'de' },
      { text: this.$t('countries.au'), value: 'au' },
      { text: this.$t('countries.fr'), value: 'fr' },
      /*{ text: this.$t('countries.ch'), value: 'ch' },
			{ text: this.$t('countries.lb'), value: 'lb' },
			{ text: this.$t('countries.li'), value: 'li' }, */
    ];
  }
}
